import Error from "next/error";
import { DANH_MUC } from "../const/danh-muc";
import { TinTucService } from "../services";
import { TinTucNew } from "../models";
import TinTucList from "../components/tin-tuc/TinTucList";
import TinTucDetail from "../components/tin-tuc/TinTucDetail";
import React = require("react");
import Layout from "../components/share/Layout";
import { PageTransition } from "next-page-transitions";
import MegastoryList from "../components/tin-tuc/MegastoryList";

const SIZE_PER_PAGE = 2;

export interface Props {
  danhSachTinTuc: TinTucNew[];
  tinTuc: TinTucNew;
  totalTinTuc: number;
  initialPage: number;
}

export interface State { }

export default class extends React.Component<any, State> {
  constructor(props) {
    super(props);
  }

  static async getInitialProps(context) {
    const layoutProps = await Layout.getInitialProps();

    const { page } = context.query;
    const initialPage = Number(page) || 1;
    return { initialPage, layoutProps };
  }

  render() {
    return (
      <Layout title={this.props.title} {...this.props.layoutProps}>
        <PageTransition timeout={400} classNames="page-transition">
            <MegastoryList
              danhSachTinTuc={this.props.danhSachTinTuc}
              totalTinTuc={this.props.totalTinTuc}
              danhMucId={DANH_MUC.MEGESTORY}
              tinTucPerPage={SIZE_PER_PAGE}
              initialPage={this.props.initialPage}
              url={this.props.url}
            />
        </PageTransition>
        <style jsx global>
          {`
                 .page-transition-enter {
                   opacity: 0;
                 }
                 .page-transition-enter-active {
                   opacity: 1;
                   transition: opacity ${400}ms;
                 }
                 .page-transition-exit {
                   opacity: 1;
                 }
                 .page-transition-exit-active {
                   opacity: 0;
                   transition: opacity ${400}ms;
                 }
               `}
        </style>

      </Layout>

    );
  }
}
